import dayjs, { Dayjs } from 'dayjs'
import { Avatar, Calendar } from '../../../../core/components'
import { colors } from '../../../../core/theme'
import { useCalendarContext } from '../CalendarPage.context'

export const CalendarComponent = () => {
  const { data, setSelected, handlePanelChangle, mode } = useCalendarContext()

  const getActivities = (moment: Dayjs) => {
    const activities = data?.filter((d: any) => {
      return dayjs(d.date).format('DD/MM/YYYY') === moment.format('DD/MM/YYYY')
    })
    return activities?.length || 0
  }

  const dateCellRender = (moment: Dayjs) => {
    const activitiesCount = getActivities(moment)
    if (!activitiesCount) return null
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Avatar style={{ backgroundColor: colors.primary }}>
          {activitiesCount}
        </Avatar>
      </div>
    )
  }

  const getMonthlyActivities = (moment: Dayjs) => {
    let activitiesCount = 0
    const activities: any = data?.filter((d: any) => {
      return dayjs(d.date).format('MM/YYYY') === moment.format('MM/YYYY')
    })

    if (activities) {
      activitiesCount = activities.length
    }
    return activitiesCount
  }

  const monthCellRender = (moment: Dayjs) => {
    const activitiesCount = getMonthlyActivities(moment)
    if (!activitiesCount) return null
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Avatar style={{ backgroundColor: colors.primary }}>
          {activitiesCount}
        </Avatar>
      </div>
    )
  }

  return (
    <Calendar
      dateCellRender={dateCellRender}
      monthCellRender={monthCellRender}
      onPanelChange={handlePanelChangle}
      // value={calendarValue}
      mode={mode}
      onSelect={(date) => {
        setSelected(date)
      }}
    />
  )
}
